import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
// Services
import { AuthService } from '@app/secure';
import { DataService } from '@app/core/services/root';
declare let window: any;
@Injectable()

export class SecureGuard implements CanActivate {
    constructor(
                private router: Router,
                private auth: AuthService,
                private dataService: DataService) {}

    public canActivate(next: ActivatedRouteSnapshot,
                state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        let response = null;
        if (this.auth.isUserLogged()) {
            response = new Promise((resolve) => {
                const gigyaAccount = window.getAccount();
                this.dataService.post('auth/login/refresh',
                    {
                        id: gigyaAccount.customerKey,
                        name: gigyaAccount.name,
                        session: gigyaAccount.session
                    })
                    .then(() => {
                        resolve(true);
                    });
            });
        }
        response = this.checkUrl(state.url);
        return response ? response : this.router.navigate(['/']);
    }

    private checkUrl(routerStateUrl): boolean {
        return (routerStateUrl === '/');
    }
}
